import useMinigrid from '../../../hook'
import TextInputSearch from '../../../../../common/components/atom/TextInputSearch/TextInputSearch'


export default function SearchMinigridPresenter() {

  const { allMinigridQuery:{ setMingridListIsLoading, setQuerySearch, getQuerySearch, setPage} } = useMinigrid()
  const inti = getQuerySearch && getQuerySearch()

  const callbackOnchange = () => {
    setPage(1)
  }
  return (
    <TextInputSearch placeholder={'Rechercher'}  setIsLoading={setMingridListIsLoading} sendQuery={setQuerySearch} valueInit={inti} onChangeCallback={callbackOnchange}/>
  )
}
